import {connect} from 'react-redux';

const mapStateToProps = (state) => {
  return {
    query: state.mode.query,
    market: state.mode.market,
    experiments: state.mode.experiments,
    fullUrl: state.mode.fullUrl,
    lang: state.mode.lang
  };
};

export default function injectMain(component) {
  return connect(mapStateToProps)(component);
}



// WEBPACK FOOTER //
// ./services/inject-main.js